export enum MED_LOCALIZATION_MODE {
  DEFAULT,
  DISABLE_WATCH_ROUTING,
}
